import React, { useEffect, useRef, useState } from "react";
import hljs from "highlight.js";
import ReactQuill from "react-quill-new";
import { Link } from "react-router-dom";
import { createEmailTemplate, createInsuranceChargesApi, createPackageApi, getInsuranceChargeApi, getPackageSizeApi, getWarehouseAddressApi, updateWarehouseAddressApi } from "../../apiHelper/authService";
import { useDispatch } from "react-redux";
import { useSelector } from "react-redux";
import { clearSelectedPackage } from "../../redux/authModalSlice";
import { useNavigate } from "react-router-dom";
import toast from "react-hot-toast";
const Warehouse = () => {

    const { selectedPackage } = useSelector((state) => state.authModal);
    const { user } = useSelector((state) => state.authModal);
    const fromCountry = user?.from;
    const toCountry = user?.to;
    const warehouseInputRef = useRef(null);
    const [warehouseAddress, setWarehouseAddress] = useState("");
    const [warehouseCoordinates, setWarehouseCoordinates] = useState({ lat: null, lng: null });


    // eslint-disable-next-line no-unused-vars
    const [isHighlightReady, setIsHighlightReady] = useState(false);
    const dispatch = useDispatch()

    useEffect(() => {
        // Load highlight.js configuration and signal when ready
        hljs?.configure({
            languages: [
                "javascript",
                "ruby",
                "python",
                "java",
                "csharp",
                "cpp",
                "go",
                "php",
                "swift",
            ],
        });
    }, []);


    // Quill editor modules with syntax highlighting (only load if highlight.js is ready)
    const modules = isHighlightReady
        ? {
            syntax: {
                highlight: (text) => hljs?.highlightAuto(text).value, // Enable highlight.js in Quill
            },
            toolbar: {
                container: "#toolbar-container", // Custom toolbar container
            },
        }
        : {
            toolbar: {
                container: "#toolbar-container", // Custom toolbar container
            },
        };

    const formats = [
        "font",
        "size",
        "bold",
        "italic",
        "underline",
        "strike",
        "color",
        "background",
        "script",
        "header",
        "blockquote",
        "code-block",
        "list",
        "indent",
        "direction",
        "align",
        "link",
        "image",
        "video",
        "formula",
    ];


    const [percentAmount, setPercentAmount] = useState('');
    const [gstPercent, setGstPercent] = useState('');
    const [uptoVal, setUptoVal] = useState('');

    const [loading, setLoading] = useState(false)




    useEffect(() => {
        if (window.google && warehouseInputRef.current) {
            const autocomplete = new window.google.maps.places.Autocomplete(warehouseInputRef.current, {
                fields: ['formatted_address', 'geometry'],
            });

            autocomplete.addListener('place_changed', () => {
                const place = autocomplete.getPlace();

                if (!place.geometry) {
                    alert("❌ Please select a valid location from the dropdown.");
                    return;
                }

                setPercentAmount(place.formatted_address);
                setWarehouseCoordinates({
                    lat: place.geometry.location.lat(),
                    lng: place.geometry.location.lng(),
                });
            });
        }
    }, []);

    console.log("Warehouse coordinates : ", warehouseCoordinates)






    const getInsuranceCharges = async () => {
        setLoading(true);



        // const toastId = toast.loading("Fetching Email Templates...");

        try {
            const data = await getWarehouseAddressApi();
            console.log(data)
            // setShipmentCharges(data?.shipmentCharges || []);
            setPercentAmount(data?.address)
            // setGstPercent(data?.gst_percentage)
            // setUptoVal(data?.upto_value)



            // setCategories(data);
            // setPackageData(data)
            // toast.success("Email Templates fetched successfully!", { id: toastId });
        } catch (err) {
            console.error("Fetch Error:", err);

            // toast.error(
            //     err?.message || "Something went wrong while fetching email templates.",
            //     { id: toastId }
            // );
        } finally {
            setLoading(false);
        }
    };

    const validateAddressWithGeocoding = async (address) => {
        const apiKey = "AIzaSyBCTwK_-gbZaU_OdIy5M8Ym4OTmgPU-jcw"; // Replace with your real API key
        const url = `https://maps.googleapis.com/maps/api/geocode/json?address=${encodeURIComponent(address)}&key=${apiKey}`;

        try {
            const res = await fetch(url);
            const data = await res.json();

            if (data.status === "OK" && data.results.length > 0) {
                const location = data.results[0].geometry.location;
                return {
                    isValid: true,
                    formattedAddress: data.results[0].formatted_address,
                    coordinates: location,
                };
            } else {
                return { isValid: false };
            }
        } catch (error) {
            console.error("Geocoding failed:", error);
            return { isValid: false };
        }
    };



    const createInsurance = async (e) => {
        e.preventDefault();
        setLoading(true);
        const { isValid, formattedAddress, coordinates } = await validateAddressWithGeocoding(percentAmount);

        if (!isValid) {
            // alert("❌ Invalid address. Please enter a valid location.");
            toast.error("Invalid address. Please enter a valid location.")
            return;
        }

        setWarehouseAddress(formattedAddress);
        setWarehouseCoordinates(coordinates);


        const toastId = toast.loading("Updating....");

        try {
            const data = await updateWarehouseAddressApi({ address: percentAmount, latitude: warehouseCoordinates?.lat, longitude: warehouseCoordinates?.lng });
            console.log(data)
            // setShipmentCharges(data?.shipmentCharges || []);



            // setCategories(data);
            // setPackageData(data)
            toast.success("Address updated successfully", { id: toastId });
        } catch (err) {
            console.error("Fetch Error:", err);

            toast.error(
                err || "Something went wrong .",
                { id: toastId }
            );
        } finally {
            setLoading(false);
        }
    };

    // console.log(ShipmentCharges)


    useEffect(() => {

        getInsuranceCharges()


    }, [])






    console.log("Package", selectedPackage)






    return (
        <div className='row gy-4'>
            <div className='col-lg-12'>
                <div className='card mt-24'>
                    <div className='card-header border-bottom'>
                        <h6 className='text-xl mb-0'>Warehouse Address</h6>
                    </div>
                    <div className='card-body p-24'>
                        <form className='d-flex flex-column gap-20' onSubmit={createInsurance}>

                            <div className="row">
                                <div className="col-12 col-md-12 mb-3">
                                    <label className='form-label fw-bold text-neutral-900' htmlFor='warehouseAddress'>
                                        Warehouse Address
                                    </label>
                                    <textarea
                                        required
                                        ref={warehouseInputRef}
                                        className='form-control border border-neutral-200 radius-8'
                                        id='warehouseAddress'
                                        placeholder='Enter Warehouse Address'
                                        rows={4} // You can adjust rows as needed
                                        value={percentAmount}
                                        onChange={(e) => setPercentAmount(e.target.value)}
                                    />
                                </div>


                            </div>














                            <div className="w-100 text-center">
                                <button type="submit" className="btn btn-primary-600 radius-8">
                                    Update
                                </button>
                            </div>

                        </form>
                    </div>
                </div>
            </div>
            {/* Sidebar Start */}

        </div>
    );
};

export default Warehouse;
